const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  // TWP CUSTOM: fired straight after an option is clicked, before the section
  // re-render comes back — lets size-dependent UI update without waiting on it.
  variantAvailabilityPreview: 'variant-availability-preview',
  cartError: 'cart-error',
};
